'use strict'

import { v4 as uuidv4 } from 'uuid'

/*
    This module generates the parameters that are passed to the API call which saves the current
    project. It's intended for private use by page_project.jsx.
*/

const getParametersForSaveProject = (
  teamId,
  loggedInId,
  projectData,
  copyOptions
) => {
  if (inputsAreInvalid(teamId, loggedInId, projectData)) {
    const err = 'One of the provided inputs did not contain data.'
    return { err }
  } else {
    return getParametersForSaveProjectCore(
      teamId,
      loggedInId,
      projectData,
      copyOptions
    )
  }
}

const getParametersForSaveProjectCore = (
  teamId,
  loggedInId,
  projectData,
  copyOptions
) => {
  const sharedData = getSharedData(teamId, loggedInId, projectData)

  if (isCopyOperation(copyOptions)) {
    return getParametersForCopyOperation(sharedData, copyOptions)
  } else {
    return getParametersForCreateOperation(sharedData, projectData)
  }
}

const getParametersForCopyOperation = (sharedData, copyOptions) => {
  const data = {
    id: copyOptions.projectId,
    projectData: {
      ...sharedData,
      percentageCompleted: 0,
      status: 'estimate'
    },
    subObjects: copyOptions.subObjects || [],
    bGetNewTitle: false
  }
  const url = '/api/project/copy'
  const operationName = 'copy'
  return { data, url, operationName }
}

const getParametersForCreateOperation = (sharedData, projectData) => {
  const status = 'active'
  const data = {
    ...sharedData,
    status: status,
    budget: {
      phases: [
        {
          title: '',
          fromDate: projectData.startDate || null,
          toDate: projectData.endDate || null,
          status: status,
          total: 0,
          percentage: 0,
          spentAmount: 0,
          cloverleafID: uuidv4()
        }
      ],
      totalSpent: 0,
      total: 0,
      noActiveTimeActivities: 1
    }
  }
  const url = '/api/project'
  const operationName = 'create'
  return { data, url, operationName }
}

const getSharedData = (teamId, loggedInId, projectData) => {
  return {
    teamId: teamId,
    createdById: loggedInId,
    title: projectData.title,
    contactId: projectData.contactId,
    startDate: projectData.startDate,
    endDate: projectData.endDate,
    projectNumber: projectData.projectNumber,
    tags: projectData.tags
  }
}

const isCopyOperation = copyOptions => copyOptions && copyOptions.projectId
const inputsAreInvalid = (teamId, loggedInId, projectData) =>
  !(teamId && loggedInId && projectData)

export { getParametersForSaveProject }
